module.exports = __webpack_public_path__ + "static/media/support-coordination-icon.e5c87a31.svg";